import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=4d52e044&"
import script from "./EventCard.vue?vue&type=script&lang=js&"
export * from "./EventCard.vue?vue&type=script&lang=js&"
import style0 from "./EventCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventCard.vue"
export default component.exports